var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('items-delivery-form',{attrs:{"entityType":"kid"},on:{"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }